import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./hero.css";
import { fadeUp, stagger, titleLine } from "../../motion";

const stats = [
  { value: "4+", label: "Years building", note: "Full-stack since 2021" },
  { value: "13+", label: "Products shipped", note: "Web & mobile launches" },
  { value: "4", label: "Companies", note: "Pakistan to Saudi Arabia" },
  { value: "RN", label: "Core stack", note: "React Native + React" },
];

const Hero = ({ ready = true }) => {
  const reduce = useReducedMotion();
  const play = ready || reduce;

  return (
    <section id="home" className="hero">
      <div className="container hero__grid">
        <motion.div
          className="hero__copy"
          variants={stagger(0.1)}
          initial={reduce ? false : "hidden"}
          animate={play ? "show" : "hidden"}
        >
          <motion.div className="hero__meta" variants={fadeUp}>
            <span className="hero__pill">
              <i /> Available for work
            </span>
            <span className="hero__place">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11Z" stroke="currentColor" strokeWidth="1.6" />
                <circle cx="12" cy="10" r="2.2" stroke="currentColor" strokeWidth="1.6" />
              </svg>
              Saudi Arabia · Riyadh
            </span>
          </motion.div>

          <motion.h1 className="hero__title" variants={stagger(0.12)}>
            <span className="hero__title-line">
              <motion.span className="serif" variants={titleLine}>
                Mustafa
              </motion.span>
            </span>
            <span className="hero__title-line">
              <motion.span className="serif hero__title-accent" variants={titleLine}>
                Zeb
              </motion.span>
            </span>
          </motion.h1>

          <motion.p className="hero__role" variants={fadeUp}>
            <span /> React Native Developer & IT Project Manager
          </motion.p>

          <motion.p className="hero__bio" variants={fadeUp}>
            React Native developer with 4+ years building mobile, web, and desktop
            apps — leading teams, shipping Eventy, Timeloop, and HR products, and
            delivering scalable solutions with Agile/Scrum.
          </motion.p>

          <motion.div className="hero__cta" variants={fadeUp}>
            <a href="#work" className="btn btn-primary btn-glow">
              View selected work
            </a>
            <a href="#contact" className="btn">
              Get in touch
            </a>
          </motion.div>

          <motion.div className="hero__stats" variants={stagger(0.06)}>
            {stats.map((item) => (
              <motion.article key={item.label} variants={fadeUp}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
                <small>{item.note}</small>
              </motion.article>
            ))}
          </motion.div>
        </motion.div>

        <div className="hero__visual" aria-hidden="true" />
      </div>

      <motion.a
        href="#about"
        className="hero__scroll"
        initial={reduce ? false : { opacity: 0, y: 8 }}
        animate={play ? { opacity: 1, y: 0 } : { opacity: 0 }}
        transition={{ delay: 0.55, duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
      >
        Scroll
        <span />
      </motion.a>
    </section>
  );
};

export default Hero;
